import * as React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";
const DoneIcon = ({ customColor, ...props }) => (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <G clipPath="url(#clip0_8164_3312)">
            <Path d="M5.99896 10.7991L3.19896 7.99909L2.26562 8.93242L5.99896 12.6658L13.999 4.66576L13.0656 3.73242L5.99896 10.7991Z" fill={customColor ?? "white"} />
        </G>
        <Defs>
            <ClipPath id="clip0_8164_3312">
                <Rect width="16" height="16" fill="white"/>
            </ClipPath>
        </Defs>
    </Svg>
);
export default DoneIcon;
